import * as React from 'react'
import {HelmetProvider} from 'react-helmet-async'
import ReactModal from 'react-modal'
// eslint-disable-next-line no-restricted-imports
import MockConfig from '~/api/mocks/config'
import type {TLoadingState} from '~/components/LoadingScreen'
import LoadingScreen from '~/components/LoadingScreen'
import {updateGlobalDataFromServer} from '~/redux/massUpdate'
import {getHistory} from '~/routing/history'
import Routes from '~/routing/routes'

interface IProps {}
interface IState {
  loadState: TLoadingState
}

export default class SinglePageApplication extends React.Component<IProps, IState> {
  state: IState = {
    loadState: 'loading',
  }

  componentDidMount() {
    // http://reactcommunity.org/react-modal/accessibility/
    ReactModal.setAppElement('#root')

    // read the query parameters in to MockConfig (only runs in the mock env)
    MockConfig.setupMockConfigParams()

    updateGlobalDataFromServer('app-load')
      .then(() => {
        this.setState({loadState: 'success'})
      })
      .catch(e => {
        console.warn(`Updating global data on app-load had an error: `, e)
        this.setState({loadState: 'failed'})
      })
  }

  render() {
    return (
      <HelmetProvider>
        <LoadingScreen loadState={this.state.loadState} renderChildrenOnFailure>
          <Routes history={getHistory()} />
        </LoadingScreen>
      </HelmetProvider>
    )
  }
}
